import React from 'react';
import { Row, Col, Typography, Card } from 'antd';
import { IPlanMeta } from '../../types/plans';

const { Text } = Typography;

interface MetaInfoProps {
  meta: IPlanMeta;
}

export const MetaInfo = ({ meta }: MetaInfoProps) => {
  if (!meta) return null;

  return (
    <Card variant="borderless" size="small" title="Meta Information">
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text strong>Type: </Text> {meta.type || 'N/A'}
        </Col>
        <Col span={24}>
          <Text strong>Outer Area: </Text> {meta.outerArea || 'N/A'} sq ft
        </Col>
        <Col span={24}>
          <Text strong>Living Area: </Text> {meta.totalArea || 'N/A'} sq ft
        </Col>
        <Col span={24}>
          <Text strong>Bathroom: </Text> {meta.bathroomCount || 'N/A'} (
          {meta.bathroom && meta.bathroom.length > 0
            ? meta.bathroom.map(area => `${area.area} sq ft`).join(', ')
            : 'N/A'}
          )
        </Col>
        <Col span={24}>
          <Text strong>Bedroom: </Text> {meta.bedroomCount || 'N/A'} (
          {meta.bedroom && meta.bedroom.length > 0
            ? meta.bedroom.map(area => `${area.area} sq ft`).join(', ')
            : 'N/A'}
          )
        </Col>
        <Col span={24}>
          <Text strong>Kitchen: </Text> {meta.kitchenCount || 'N/A'} (
          {meta.kitchen && meta.kitchen.length > 0
            ? meta.kitchen.map(area => `${area.area} sq ft`).join(', ')
            : 'N/A'}
          )
        </Col>
        <Col span={24}>
          <Text strong>Width: </Text> {meta.width || 'N/A'}&apos;
        </Col>
        <Col span={24}>
          <Text strong>Length: </Text> {meta.length || 'N/A'}&apos;
        </Col>
      </Row>
    </Card>
  );
};
